import { Card, CardContent, Typography, Box } from "@mui/material";

export const StatCard = ({ title, value, color, icon }: any) => (
  <Card 
    sx={{
      backgroundColor: 'white',
      borderTop: `4px solid ${color}`,
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      }
    }}
  >
    <CardContent sx={{ p: 3, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
        {icon}
        <Typography variant="h4" fontWeight="bold" color={color} sx={{ ml: 1 }}>
          {value}
        </Typography>
      </Box>
      <Typography color="text.secondary" variant="body2">
        {title}
      </Typography>
    </CardContent>
  </Card>
);